import React from "react";

import { OnePagePortfolioAssessmentAnswersFromOtherSchoolByClass } from "../../../../../state";
import { ReactComponent as IconUser } from "../../../../../assets/images/AnswerList/icon_user.svg";
import OneAnswerBox from "../../OneAnswerBox";

import styles from "./OtherSchoolAnswers.module.scss";

type Props = {
  answersOtherSchoolsByClasses: OnePagePortfolioAssessmentAnswersFromOtherSchoolByClass[];
};

const OtherSchoolAnswers = ({ answersOtherSchoolsByClasses }: Props) => {
  return (
    <div className={styles.answerList}>
      {answersOtherSchoolsByClasses.length > 0 ? (
        answersOtherSchoolsByClasses.map(otherSchoolsAnswer => {
          const questionAnswers = otherSchoolsAnswer.one_page_portfolio_assessments
            .flatMap(oppa => oppa.one_page_portfolio_assessment_issues)
            .flatMap(issue => issue.one_page_portfolio_assessment_questions);
          return (
            <div
              className={styles.answerFromOtherSchool}
              key={otherSchoolsAnswer.id}
            >
              <p className={styles.name}>
                <IconUser />
                {otherSchoolsAnswer.grade >= 1 && otherSchoolsAnswer.grade <= 3
                  ? `${otherSchoolsAnswer.grade}年生`
                  : "その他"}
              </p>
              <OneAnswerBox questionAnswers={questionAnswers} />
            </div>
          );
        })
      ) : (
        <p className={styles.emptyMessageBox}>まだ回答がありません。</p>
      )}
    </div>
  );
};

export default OtherSchoolAnswers;
